// eslint-disable-next-line import/prefer-default-export
export const QR_ATTENDANCE_ROUTE = '/offline/qr_attendance';
export const FACE_ATTENDANCE_ROUTE = '/offline/face_attendance';

export const ATTENDANCE_ROUTES = [FACE_ATTENDANCE_ROUTE, QR_ATTENDANCE_ROUTE];

export const LEARNER_ATTENDANCE_TAP_TO_QR_SCAN =
  'Learner Attendance - Tap to QR Scan';

export const LEARNER_ATTENDANCE_ADMIN_SWITCHED_TO_QR_SCAN_MODE =
  'Learner Attendance - Admin Switched to QR Scan Mode';
